import {bl_sch_crontab_hdr_RowClass} from "../../dbschema";

export class SchedulerContainerModel {
  bl_sch_crontab_hdr: bl_sch_crontab_hdr_RowClass = new bl_sch_crontab_hdr_RowClass();
}
